exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-9d9ab64a] .el-upload-dragger{height:130px!important;width:440px!important}[data-v-9d9ab64a] .el-upload-dragger .el-icon-upload{margin:18px 0 16px}", ""]);

// exports
